<template>
  <div class="w3-container">
    <!-- 注册表单卡片 -->
    <div class="w3-margin-top" style="max-width: 500px; margin: 0 auto">

      <!-- 注册表单 -->
      <form @submit.prevent="register" class="w3-container w3-padding-16">
        <!-- 用户名输入 -->
        <div class="w3-section">
          <label class="w3-text-blue"><b>用户名</b></label>
          <input
            type="text"
            class="w3-input w3-border"
            v-model="username"
            placeholder="请输入用户名"
            required
          >
        </div>

        <!-- 密码输入 -->
        <div class="w3-section">
          <label class="w3-text-blue"><b>密码</b></label>
          <input
            type="password"
            class="w3-input w3-border"
            v-model="password1"
            placeholder="请输入密码"
            required
          >
        </div>

        <!-- 重复密码输入 -->
        <div class="w3-section">
          <label class="w3-text-blue"><b>重复密码</b></label>
          <input
            type="password"
            class="w3-input w3-border"
            v-model="password2"
            placeholder="请输入密码"
            required
          >
        </div>

        <!-- 提交按钮 -->
        <div class="w3-section">
          <button type="submit" class="w3-button w3-blue w3-block">
            立即注册
          </button>
        </div>

        <!-- 提示消息 -->
        <div v-if="message" :class="messageClass">
          <p>{{ message }}</p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password1: '',
      password2: '',
      message: '',
      isSuccess: false // 标记是否成功
    };
  },
  computed: {
    messageClass() {
      return this.isSuccess 
        ? 'w3-panel w3-green w3-round' 
        : 'w3-panel w3-red w3-round';
    }
  },
  methods: {
    async register() {
      try {
        // 检查用户名和密码是否为空
        if (!this.username || !this.password1|| !this.password2) {
          this.message = '用户名和密码不能为空';
          this.isSuccess = false;
          return;
        }
        // 检查两次密码是否一致
        if (this.password1 !== this.password2) {
          this.isSuccess = false;
          this.message = '两次密码不一致';
          return;
        }

        const response = await fetch(`${this.$apiUrl}/regAcct`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.username,
            password: this.password1
          })
        });

        const data = await response.json();
        console.log(data);
        this.isSuccess = data.code === 200;
        this.message = data.msg || (this.isSuccess ? '注册成功！' : '注册失败');

        //清空表单
        this.username = '';
        this.password1 = '';
        this.password2 = '';

      } catch (error) {
        console.error(error);
        this.isSuccess = false;
        this.message = '网络错误，请检查连接';
      }
    }
  }
};
</script>

<style scoped>
/* 可选：自定义补充样式 */
.w3-card-4 {
  margin-top: 30px;
}

.w3-input {
  margin-top: 5px;
}
</style>